import { FC } from "preact/compat";
import { useApp } from "~/core/store";
import { IconButton } from "~/components";
import TileTotalToday from "./TileTotalToday";
import { TileProps } from "./interfaces";
import FastRewindIcon from "@material-design-icons/svg/outlined/fast_rewind.svg";
import PauseIcon from "@material-design-icons/svg/outlined/pause.svg";
import PlayIcon from "@material-design-icons/svg/outlined/play_arrow.svg";
import cn from "classnames";

const Tile: FC<TileProps> = ({ tile }) => {
    const {
        tracker: { activeTask, activeTile, activeExternal, stop, startTile },
        api,
        snack,
    } = useApp();
    const active = activeTask.value ?? activeTile.value ?? activeExternal.value;

    const handleClick = () => {
        if (active?.id === tile.id && active?._track) {
            stop(active._track);
        } else if (tile.type === "track_group") {
            startTile(tile._trackGroup);
        }
    };

    const handleChangeStart = async (date: Date) => {
        if (
            !active ||
            !active._track ||
            active.startDate?.getTime() === date.getTime()
        ) {
            return;
        }

        try {
            await api.time.track.update({
                id: active._track,
                start: date,
            });
        } catch (err: unknown) {
            console.log("[tracker play back]: error happened", err);
            snack.error("Error happened", "Couldn't change track start time");
        }
    };

    const handlePlay5MinutesBack = () => {
        if (!active || !active.startDate) {
            return;
        }

        const newDate = new Date(active.startDate);

        newDate.setMinutes(newDate.getMinutes() - 5);

        handleChangeStart(newDate);
    };

    return (
        <div
            className={cn(
                "grid grid-cols-4 items-center gap-x-2 rounded-xl border border-gray-300 bg-white p-2",
                active?.id === tile.id && "bg-sky-100",
            )}
        >
            <div className="col-span-3 flex items-center">
                <IconButton onClick={handleClick}>
                    {active?.id === tile.id ? (
                        <PauseIcon width="18" height="18" />
                    ) : (
                        <PlayIcon width="18" height="18" />
                    )}
                </IconButton>
                <span className="ml-4">{tile.name}</span>
            </div>
            <div>
                <div className="mb-1 text-xs text-gray-500">Tracked today</div>
                <TileTotalToday tile={tile} />
            </div>
            {active?.id === tile.id && (
                <div className="col-span-4 mt-2 flex items-center">
                    <IconButton onClick={handlePlay5MinutesBack}>
                        <FastRewindIcon width="18" height="18" />
                    </IconButton>
                    <span className="ml-4 text-gray-400">
                        Start 5 minutes earlier
                    </span>
                </div>
            )}
        </div>
    );
};

export default Tile;
